module.exports = __webpack_public_path__ + "img/sir_yes.d7a7a99e.png";